(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag1-content"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ag1-content'))customElements.define('ag1-content',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const strip=this.querySelector('[data-slides]');if(!strip)return;const buttons=this.querySelectorAll('[data-slide-index]');buttons.forEach(button=>button.addEventListener('click',()=>{strip.scrollTo({left:strip.clientWidth*Number(button.dataset.slideIndex),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}));let frame;strip.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{const selected=Math.round(strip.scrollLeft/strip.clientWidth);buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===selected)))})},{passive:true})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag1-orbit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ag1-orbit')){customElements.define('ag1-orbit',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const cards=this.querySelectorAll('.ao-card');cards.forEach((card,index)=>card.addEventListener('click',()=>{cards.forEach(c=>c.setAttribute('aria-pressed','false'));card.setAttribute('aria-pressed','true');this.dataset.active=String(index+1);this.querySelector('[data-detail-output]').textContent=card.dataset.detail}));const pack=this.querySelector('[data-pack]');if(pack){const update=()=>{const option=pack.selectedOptions[0];this.querySelector('[data-shop]').href=option.value;this.querySelector('.ao-cta [data-price]').textContent=option.dataset.price};pack.addEventListener('change',update);update()}}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
